import changeCities from "../modules/Utils/changeCities";

changeCities();

document.addEventListener('DOMContentLoaded', function () {
    // swipers
    const swiperTestimonials = new Swiper('.swiper-testimonials', {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 30,
        loop: true,
        speed: 900,

        autoplay: {
            delay: 6000,
            disableOnInteraction: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 80,
            }
        }
    });
});